import { c as _c } from "react/compiler-runtime";
import { useAppSelector } from "@store/store-helper";
import { hasInProgressUploadTasksSelector } from "@store/upload-tasks/upload-tasks-selector";
import { useBeforeUnload } from "react-router-dom";

/**
 * @returns the logic to prevent the browser tab from closing if there are any task in-progress.
 */
export function useHandleWindowClose() {
  const $ = _c(2);
  const hasInProgressUploadTask = useAppSelector(hasInProgressUploadTasksSelector);
  let t0;
  if ($[0] !== hasInProgressUploadTask) {
    t0 = ev => {
      if (hasInProgressUploadTask) {
        ev.preventDefault();
        ev.returnValue = "";
      }
    };
    $[0] = hasInProgressUploadTask;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useBeforeUnload(t0);
}